<template>
  <!-- COMPONENT WRAPPER -->
  <div>
    <div>
      <v-btn
        @click="isActivationVisible = true"
        icon
        x-small
        :class="
          `mr-2 ${
            navigatorLocation.active ? 'text--secondary' : 'text--disabled'
          }`
        "
      >
        <v-icon x-small>fas fa-location-arrow</v-icon>
      </v-btn>
      <span
        @click="isActivationVisible = true"
        v-text="
          navigatorLocation.active
            ? $t('search.clientLocationActivated')
            : $t('search.clientLocationNotActivated')
        "
        class="caption text-decoration-underline cusor-on-hover--pointer "
        v-bind:class="{
          'text--secondary': navigatorLocation.active,
          'text--disabled': !navigatorLocation.active
        }"
      >
      </span>
    </div>
    <v-dialog
      :value="isActivationVisible"
      persistent
      width="500"
      :fullscreen="$vuetify.breakpoint.mobile"
    >
      <v-sheet
        class="d-flex flex-column flex-wrap"
        v-bind:class="{ 'rounded-2': !$vuetify.breakpoint.mobile }"
        height="100%"
      >
        <!-- HEADER -->
        <div class="relative">
          <v-progress-linear
            v-show="isFetchingNavigatorLocation"
            color="secondary"
            indeterminate
            absolute
            height="4"
            top
            left
            right
          ></v-progress-linear>
          <div class="d-flex justify-space-between align-center px-4 py-2">
            <h3
              class="primary--text"
              v-text="$t('search.localisationTitle')"
            ></h3>
            <v-btn icon @click="isActivationVisible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-divider></v-divider>
        </div>
        <!-- MAIN -->
        <div
          class="text-center flex-grow-1 d-flex align-center justify-center pa-4"
        >
          <div>
            <v-icon size="320px" class="mx-auto d-block">
              {{
                `$${
                  !navigatorLocation.active
                    ? "activateLocation"
                    : "desactivateLocation"
                }`
              }}
            </v-icon>
            <v-btn
              @click="
                !navigatorLocation.active
                  ? searchNavigatorLocation()
                  : removeClientLocation()
              "
              depressed
              :text="true"
              v-text="
                navigatorLocation.active
                  ? $t('search.desactivateClientLocation')
                  : $t('search.activateClientLocation')
              "
              :color="!navigatorLocation.active ? 'success' : 'error'"
              class="mr-4"
            >
            </v-btn>
            <v-scale-transition>
              <div
                v-if="navigatorLocation.error"
                class="px-4 pb-2 text-justify"
              >
                <span class="red--text caption">
                  {{ $t("searchBar.unableToGetYourLocation") }}
                </span>
              </div>
            </v-scale-transition>
          </div>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
export default {
  // COMPONENT NAME
  name: "SearchLocationActivation",
  // DATA
  data() {
    return {
      isActivationVisible: false,
      isFetchingNavigatorLocation: false,
      navigatorLocation: {
        active: false,
        error: false,
        loading: false,
        object: {}
      }
    };
  },
  // METHODS
  methods: {
    askNavigatorLocation() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          response => resolve(response),
          error => reject(error)
        );
      });
    },
    searchNavigatorLocation() {
      this.navigatorLocation.error = false;
      this.isFetchingNavigatorLocation = true;
      this.askNavigatorLocation()
        .then(response => {
          this.navigatorLocation.active = true;
          this.navigatorLocation.object = response;
          sessionStorage.setItem(
            "clientLongitude",
            this.navigatorLocation.object.coords.longitude
          );
          sessionStorage.setItem(
            "clientLatitude",
            this.navigatorLocation.object.coords.latitude
          );
          this.isActivationVisible = false;
          this.$emit("redoSearch");
        })
        .catch(() => (this.navigatorLocation.error = true))
        .finally(() => (this.isFetchingNavigatorLocation = false));
    },
    removeClientLocation() {
      sessionStorage.removeItem("clientLongitude");
      sessionStorage.removeItem("clientLatitude");
      this.isActivationVisible = false;
      this.navigatorLocation.error = false;
      this.navigatorLocation.active = false;
      this.$emit("redoSearch");
    }
  },
  // LIFE CYCLE HOOKS
  created() {
    if (
      sessionStorage.getItem("clientLongitude") &&
      sessionStorage.getItem("clientLatitude")
    ) {
      this.navigatorLocation.active = true;
      this.navigatorLocation.object.coords = {
        longitude: sessionStorage.getItem("clientLongitude"),
        latitude: sessionStorage.getItem("clientLatitude")
      };
    } else {
      this.searchNavigatorLocation();
    }
  }
};
</script>
